export const DEVICE_INFO_SERVICE_UUID = '0000180a-0000-1000-8000-00805f9b34fb';
export const MANUFACTURER_NAME_CHAR_UUID = '00002a29-0000-1000-8000-00805f9b34fb';
export const FIRMWARE_REVISION_CHAR_UUID = '00002a26-0000-1000-8000-00805f9b34fb';
export const HARDWARE_REVISION_CHAR_UUID = '00002a27-0000-1000-8000-00805f9b34fb';
export const BATTERY_SERVICE_UUID = '0000180f-0000-1000-8000-00805f9b34fb';
